export default __webpack_public_path__ + "static/media/Wall of Eternal Winter.bae915cd.jpg";